import {  WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";


import { defaultDropList } from "../Data/WBComponentDefaults";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import WebDesigner from "../WebDesigner";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { GetNodeComponenentAttributeBinding, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import CreateAttributeList, { attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import RenderNavigationList from "vagaro-website-rendering/src/components/ComponentRenders/RenderNavigationList";





export default class NavigationList extends WBComponent {
  constructor() {
    super();
    this.typename = wBComponentTypeNames.navigationList;
    this.displayName = "Navigation Menu";
    this.dropList = defaultDropList;
  this.editList = [
      "gap",
      "buttonName",
      "link",
      "logo",
      "navBreakPoint",
      attributeTypes.justifyContent,
      attributeTypes.alignContent,
      attributeTypes.alignItems,
      "justifyHorizontal",
      "alignVertical",
      ...CreateAttributeList(true, true, true, true, true),
      "hoverColor",
      "hoverBackground",
      "dropdownBackground",
    ];

    this.primaryEditAttributes = [
      "navBreakPoint",
      "justifyHorizontal",
      "alignVertical",
      "gap",
      "hoverColor",
      "hoverBackground",
      "dropdownBackground",
      "buttonName",
      "link",
      "logo",
 
    ];

    this.contentEditable = false;
    this.icon = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 0 448 512"
        fill="currentColor"
      >
        <path d="M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24z" />
      </svg>
    );
  }

  onFirstTimeCreation(
    newParent: LayoutNode,
    thisLayout: LayoutNode,
    manager: WebDesigner
  ): void {
    thisLayout.screenSizeStyleAttributes[ScreenSize.Desktop] = {
      justifyContent: "center",
    };
  }

  getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {


    let btnName =       new AttributeDefinition(
        "buttonName",
        "Optional Button",
        "",
        AttributeInputType.InputFiled
      );

      btnName.placeHolder = "Book Now..."

    return [
      new AttributeDefinition(
        "navCollapse",
        "Collapse Items",
        "",
        AttributeInputType.ButtonField,
        [
          { label: "Auto", value: "" },
          { label: "Tablet", value: "tablet" },
          { label: "Mobile", value: "mobile" },
          { label: "None", value: "none" },
        ]
      ),
      new AttributeDefinition(
        "dropdownBackground",
        "Dropdown Background",
        "",
        AttributeInputType.ColorField
      ),
      new AttributeDefinition(
        "hoverColor",
        "Hover Color",
        "",
        AttributeInputType.ColorField
      ),

      new AttributeDefinition(
        "hoverBackground",
        "Hover Background",
        "",
        AttributeInputType.ColorField
      ),
      new AttributeDefinition(
        "navBreakPointz",
        "Collapse Menu",
        "",
        AttributeInputType.ButtonField,
        [
          { label: "Mobile", value: "" },
          { label: "Tablet", value: ".tablet-break" },
          { label: "Desktop", value: "desktop" },
        ]
      ),
      new AttributeDefinition(
        "logo",
        "Logo",
        "",
        AttributeInputType.ImageField

      ),
      btnName
    ];
  }

  GetComponentGlobalCSS(node: LayoutNode): string {
    return getStyling(node, false);
  }

  RenderLayout({
    component,
    children,
    screenSize,
    userContext: siteData,
    isEditor,
  }: WBRenderProps) {
    const atts = GetNodeDomAttributes(
      "v-navigation-list flex-wrap max-100 full-width-mobile",
      component,
      screenSize,
      isEditor
    );

    //if(isEditor){
    let pages = [...siteData.pages].filter((val) => {
      return (!val.isDisabled && !val.isHidePage);
    });

    for (let i = 0; i < pages.length; i++) {
      if (pages[i].isFolder && pages[i].children) {
        pages[i] = { ...pages[i] }; //clone the folder
        pages[i].children = pages[i].children?.filter((val) => {
          return (!val.isDisabled && !val.isHidePage);
        });
      }
    }

    setNodeComponentAttributeValue(component, "pages", JSON.stringify(pages));
    // }

    return (
      <>
        {isEditor && ( //include styling inline in editor
          <style>{getStyling(component, true)}</style>
        )}
        <div
          {...atts}
          {...GetNodeComponenentAttributeBinding(component, isEditor)}
        >
          <RenderNavigationList node={component} isEditor={isEditor} />
        </div>
      </>
    );
  }
}


function  getStyling(node:LayoutNode,isEditor:boolean){

    const hoverBackground = getNodeComponentAttributeValue(node,"hoverBackground","inherit");
    const hoverColor = getNodeComponentAttributeValue(node,"hoverColor","inherit");
    const dropdownColor = getNodeComponentAttributeValue(node,"dropdownBackground","var(--default-bg-color)");
    const id = (isEditor)?node.id:"v"+node.id;
    let breakClass = getNodeComponentAttributeValue(node,"navBreakPoint",".mobile-break");
    if(breakClass == "desktop")
        breakClass = "";
    return `

    ${breakClass}  #${id} .full-navigation, ${breakClass}  #${id} .nav-button, ${breakClass} #${id} .nav-logo  {
        display:none !important;
    }
    ${breakClass}  #${id} .mobile-navigation {
        display:block !important;
    }

    ${breakClass}  #${id}.v-navigation-list {
        width:100%;
    }


    #${id} .no-a:hover, #${id} .no-link:hover, #${id} .nav-link:hover {
        background-color:${hoverBackground};
        color:${hoverColor};
    }
    #${id} .v-navigation-child-list  {
        background-color:${dropdownColor} !important;
    }

    #${id} .mobile-navigation-content  {
        background-color:${dropdownColor} !important;
    }

`
}




